export function articulosConInformacionMinifichaConfirming(articulosParaConfirmar) {
    return new Promise((resolve) => {
        let content = '<ul class="text-start">';
        articulosParaConfirmar.forEach(function (articulo) {
            content += `<li><strong>${articulo.ean}</strong>: ${articulo.informacionMinificha}</li>`;
        });
        $.confirm({
            columnClass: 'col-md-6',
            icon:        'ri-alert-fill ri-xxs',
            title:       'Atención',
            type:        'orange',
            content:     content,
            buttons:     {
                confirm: {
                    text:     'Confirmar',
                    btnClass: 'btn btn-success float-end',
                    action:   function () {
                        resolve(true);
                    }
                },
                cancel:  {
                    text:     'cancelar',
                    btnClass: 'btn btn-light float-start',
                    action:   function () {
                        resolve(false);
                    }
                }
            },
        });
    });
}
